@let doc = node()?.document;

<div
  class="card"
  [class.is-nested]="nested">
  <div class="card-header">
    <span class="text is-bolder">{{ doc?.category_tag }}</span>

    <topo-ratings-bar
      horizontal
      small
      [label]="ratingText()"
      [value]="doc?.custom_rating_number ?? doc?.rating_number" />
  </div>
  <div class="card-body">
    <div
      class="overview-document-content pt-4"
      [innerHtml]="doc?.intel"></div>
    @if (node()?.children.length) {
      <div class="nested-cards-container">
        @for (childNode of node()?.children; track childNode.id) {
          <topo-ratings-document-card
            nested
            [node]="childNode" />
        }
      </div>
    }
  </div>
</div>
